module.exports = __webpack_public_path__ + "static/rockthevote-dc7ea82c94424444d954e43ede8ee01d.png";